<template>
  <VPanel class="relative p-6 overflow-hidden">
    <div class="flex justify-between">
      <h1 class="text-lg">مدیریت نقش ها</h1>

      <a href="#" @click.prevent="modalCreate = true"
         class="flex items-center border border-dark-line rounded-lg px-4 py-3 hover:bg-accent">
        <PlusIcon class="ml-2"/>
        افزودن نقش
      </a>
    </div>
    <hr class="border-dark-line mt-6">

    <table class="w-full text-right mt-4">
      <thead>
      <tr class="text-sm text-muted">
        <th class="p-4">ردیف</th>
        <th>نام نقش</th>
        <th>اتاق</th>
        <th>نوع</th>
        <th>عملیات</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(role, index) in roles"
          :key="role.id">
        <td class="p-8">{{ index + 1 }}</td>
        <td>{{ role.name }}</td>
        <td>{{ role.from_room_number || '' }} - {{role.to_room_number || '' }}</td>
        <td>
          <VBadge type="success">
            {{ role.type }}
          </VBadge>
        </td>
        <td>
          <a href="#" @click.prevent="editRole = role; modalEdit = true">
            <PenIcon class="text-orange"/>
          </a>
        </td>
      </tr>
      </tbody>
    </table>

    <ModalRole
        :show="modalCreate"
        @click="modalCreate = !modalCreate"
        @created="roleCreated"/>

    <ModalRole
        :show="modalEdit"
        @click="modalEdit = !modalEdit"
        :role="editRole"
        @edited="roleEdited"/>


    <VLoadingScreen :show="loading"/>

  </VPanel>
</template>

<script>
import {getRoles} from "@/API/API";
import VPanel from "@/components/VPanel";
import PlusIcon from "@/components/Icons/PlusIcon";
import VLoadingScreen from "@/components/General/VLoadingScreen";
import PenIcon from "@/components/Icons/PenIcon";
import ModalRole from "@/components/Modal/ModalRole";
import VBadge from "@/components/General/VBadge";

export default {
  name: "RoleView",
  components: {VBadge, ModalRole, PenIcon, VLoadingScreen, PlusIcon, VPanel},
  data() {
    return {
      roles: [],
      loading: true,
      modalCreate: false,
      modalEdit: false,
      editRole: {}
    }
  },
  async created() {
    this.roles = (await getRoles()).data
    this.loading = false
  },
  methods: {
    async roleCreated() {
      this.modalCreate = false
      this.loading = true
      this.roles = (await getRoles()).data
      this.loading = false
    },
    async roleEdited() {
      this.modalEdit = false
      this.loading = true
      this.roles = (await getRoles()).data
      this.loading = false
    }
  }
}
</script>

<style scoped>

</style>